import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // 登录页
  {
    path: '/',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },

  // 布局页
  {
    path: '/layout',
    name: 'layout',
    component: () => import('../views/Layout.vue'),
    meta: { requiresAuth: true },
    redirect: '/layout/uploadSystem/fileList',
    children: [
      // 测试页面
      // {
      //   path: 'test',
      //   name: 'test',
      //   component: () => import('../views/Test.vue')
      // },
      // 首页
      {
        path: 'indexPage',
        name: 'indexPage',
        component: () => import('../views/IndexPage.vue')
      },
      // 使用说明
      {
        path: '/useDirections',
        name: 'useDirections',
        component: () => import('../views/UseDirections.vue')
      },
      // 制作流程
      {
        path: 'productionProcess',
        name: 'productionProcess',
        component: () => import('../views/other/ProductionProcess.vue')
      },
      {
        path: 'remarkManage',
        name: 'remarkManage',
        component: () => import('../views/RemarkManage.vue')
      },
      // 模组语料上传   
      {
        path: 'uploadModule',
        name: 'uploadModule',
        component: () => import('../views/moduleSystem/UploadModule.vue')
      },
      // 模组语料上传   
      {
        path: 'editMod',
        name: 'editMod',
        component: () => import('../views/moduleSystem/EditMod.vue')
      },
      // 模组语料列表
      {
        path: 'moduleList',
        name: 'moduleList',
        component: () => import('../views/moduleSystem/ModuleList.vue')
      },
      // 一级二级模组语料整合列表
      {
        path: 'flatModuleList',
        name: 'flatModuleList',
        component: () => import('../views/moduleSystem/FlatModuleList.vue')
      },
      // 模组审核界面
      {
        path: 'auditMod',
        name: 'auditMod',
        component: () => import('../views/moduleSystem/AuditMod.vue')
      },
      // 模组回收站
      {
        path: 'recycleBin',
        name: 'recycleBin',
        component: () => import('../views/moduleSystem/RecycleBin.vue')
      },
      
      // 上传管理
      {
        path: 'uploadSystem',
        name: 'uploadSystem',
        component: () => import('../views/UploadSystem.vue'),
        children: [
          {
            path: 'funAnnatation',
            name: 'funAnnatation',
            component: () => import('../components/FunAnnatation.vue')
          },
          {
            path: 'uploadEnt',
            name: 'uploadEnt',
            component: () => import('../views/upload/UploadEnt.vue')
          },
          {
            path: 'uploadPcb',
            name: 'uploadPcb',
            component: () => import('../views/upload/UploadPcb.vue')
           
          },
          {
            path: 'fileList',
            name: 'fileList',
            component: () => import('../views/upload/FileList.vue'),
            meta: { keepAlive: true }
          },
          {
            path: 'eggShell',
            name: 'eggShell',
            component: () => import('../views/upload/EggShell.vue')
            // meta: { keepAlive: true }
          },
          {
            path: 'audit',
            name: 'audit',
            component: () => import('../views/upload/Audit.vue'),
            meta: { keepAlive: true }
          },
          {
            path: 'auditPage',
            name: 'auditPage',
            component: () => import('../views/upload/AuditPage.vue')
          },
          {
            path: 'PCBList',
            name: 'PCBList',
            component: () => import('../views/upload/PCBList')
          },
          {
            path: 'splitSheet',
            name: 'splitSheet',
            component: () => import('../views/upload/SplitSheet')
          },
          {
            path: 'PCBInfo',
            name: 'PCBInfo',
            component: () => import('../views/upload/PCBInfo.vue')
          }
        ]
      },
      // 用户管理
      {
        path: 'userManagement',
        name: 'userManagement',
        component: () => import('../views/userManage/UserManagement.vue'),
        redirect: '/layout/userManagement/userList',
        children: [
          {
            path: 'userList',
            name: 'userList',
            component: () => import('../views/userManage/UserList.vue')
          },
          {
            path: 'userSetting',
            name: 'userSetting',
            component: () => import('../views/userManage/UserSetting.vue')
          }
        ]
      },
      // 标注管理
      {
        path: 'annotationSystem',
        name: 'annotationSystem',
        component: () => import('../views/AnnotationSystem.vue'),
        redirect: '/layout/annotationSystem/chosePic',
        children: [
       
          {
            path: 'upload',
            name: 'upload',
            component: () => import('../views/annotation/Upload.vue')
          },
          {
            path: 'chosePic',
            name: 'chosePic',
            component: () => import('../views/annotation/ChosePic.vue')
          },
          {
            path: 'reviewPic',
            name: 'reviewPic',
            component: () => import('../views/annotation/ReviewPic.vue')
          },
          {
            path: 'annotate',
            name: 'annotate',
            component: () => import('../views/annotation/Annotate.vue')
          },
          {
            path: 'extract',
            name: 'extract',
            component: () => import('../views/annotation/Extract.vue')
          },
          {
            path: 'manage',
            name: 'manage',
            component: () => import('../views/annotation/Manage.vue')
          },
          {
            path: 'record',
            name: 'record',
            component: () => import('../views/annotation/Record.vue')
          },
          {
            path: 'review',
            name: 'review',
            component: () => import('../views/annotation/Review.vue')
          }
          
        ]
      }

    ]
  }
  // 标注系统
 
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {  
  // 验证token，只有存在token时才能跳转到内容页  
  const token = sessionStorage.getItem('token')  
  if (!token && to.path !== '/login') { 
    next('/login')
  } else { 
    if (from.name === 'uploadEnt' && to.name === 'fileList') {
      to.meta.keepAlive = false
    } 
    next()  
  }  
}) 

export default router
